export default `
# Workflow Execution Report

## Workflow Inputs
\`\`\`galaxy
invocation_inputs()
\`\`\`

## Workflow Outputs
\`\`\`galaxy
invocation_outputs()
\`\`\`

## Workflow
\`\`\`galaxy
workflow_display()
\`\`\`
`;
